<template>
  <transition name="fade">
    <div>
      <div class="pop-up-bg" @click.prevent="$emit('close', false)"></div>
      <div class="pop-up pop-up--delete">
        <a class="pop-up__close icon icon-close" @click.prevent="$emit('close', false)"></a>
        <h2>{{data.name.name}}</h2>
        <div class="block-data">

          <div v-show="data.mod == 'delete'">
            
            <div class="img warning"></div>
            <h3>{{$root.langText.isDelete}} {{data.name.name}}?</h3>

          </div>
          <div v-show="data.mod == 'copy'">
            
            <div class="img warning"></div>
            <h3>{{$root.langText.isCopying}} {{data.name.name}}?</h3>

          </div>



          <div v-show="data.mod !== 'copy' && data.mod !== 'delete'">
            <!-- direction -->
            <div v-if="data.name.mode == 'directions'">

              <Autocomplete 
                :data="{name: $root.langText.directory.country, mod: 'countries', key: 'countries', input: directions.countries, inputId: directions.countries_id}" 
                @result="autocompleteResult" 
              />

              <div class="form__checkbox">
                <label>
                  <input 
                    type="checkbox"
                    v-model="directions.is_main"
                  >
                  <span>{{$root.langText.input.main}}</span>
                </label>
              </div>


              <Autocomplete 
                :data="{
                  name: $root.langText.input.manager, 
                  mod: 'contact', 
                  key: 'manager', 
                  input: directions.manager, 
                  inputId: directions.manager_id, 
                  idClient: data.id, 
                  typeClient: 'contractor'
                }" 
                @result="autocompleteResult" 
              />
                      
            </div>
            



            <!-- transport_companies -->
            <div v-if="data.name.mode == 'transport_companies'">

              <Autocomplete 
                :data="{name: $root.langText.input.type, mod: 'carType', key: 'type', input: transport_companies.type, inputId: transport_companies.type_id}" 
                @result="autocompleteResult" 
              />


              <div class="form__row form__row-50">
                <div class="form__input">
                  <input 
                    type="number"
                    v-model="transport_companies.quantity"
                  >
                  <span>{{$root.langText.input.quantity}}</span>
                </div>


                <div class="form__input">
                  <input 
                    type="number"
                    v-model="transport_companies.capacity"
                  >
                  <span>{{$root.langText.input.liftingCapacity}}</span>
                </div>
              </div>

              <div class="form__row form__row-50">
                <div class="form__input">
                  <input 
                    type="number"
                    v-model="transport_companies.volume"
                  >
                  <span>{{$root.langText.input.volume}}</span>
                </div>
                <div class="form__input"></div>
              </div>
                      
            </div>



            
          </div>
        </div>



        <div class="block-btn block-btn--color" v-if="data.mod == 'copy'">
          <a class="btn btn-primary" @click.prevent="save()">{{$root.langText.copy}}</a>
          <a class="btn btn-secondary" @click.prevent="$emit('close', false)">{{$root.langText.cancel2}}</a>
        </div>

        <div class="block-btn block-btn--color" v-else-if="data.mod == 'delete'">
          <a class="btn btn-primary" @click.prevent="removedata()">Видалити{{$root.langText.delete}}</a>
          <a class="btn btn-secondary" @click.prevent="$emit('close', false)">{{$root.langText.keep}}</a>
        </div>

        <div class="pop-up__btn pop-up__btn--one" v-else>
          <a class="btn btn-primary" v-if="hidden" @click.prevent="save()">{{$root.langText.save}}</a>
        </div>



      </div>
    </div>
  </transition>
</template>



<style lang="scss">
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to{
    opacity: 0;
  }
  .warning{
    background-image: url("data:image/svg+xml,%3Csvg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 511.999 511.999' style='enable-background:new 0 0 511.999 511.999;' xml:space='preserve'%3E%3Cpath style='fill:%23E50027;' d='M501.449,368.914L320.566,66.207C306.751,43.384,282.728,29.569,256,29.569 s-50.752,13.815-64.567,36.638L10.55,368.914c-13.812,23.725-14.113,51.954-0.599,75.678c13.513,23.723,37.836,37.838,65.165,37.838 h361.766c27.329,0,51.653-14.115,65.165-37.838C515.563,420.868,515.262,392.639,501.449,368.914z'/%3E%3Cpath style='fill:%23C1001F;' d='M502.049,444.592c-13.513,23.723-37.836,37.838-65.165,37.838H256V29.57 c26.727,0,50.752,13.815,64.567,36.638L501.45,368.915C515.262,392.639,515.563,420.868,502.049,444.592z'/%3E%3Cpath style='fill:%23FD003A;' d='M75.109,452.4c-16.628,0-30.851-8.27-39.063-22.669c-8.211-14.414-8.065-31.087,0.469-45.72 L217.23,81.549c8.27-13.666,22.816-21.951,38.769-21.951s30.5,8.284,38.887,22.157l180.745,302.49 c8.388,14.4,8.534,31.072,0.322,45.485c-8.211,14.4-22.435,22.669-39.063,22.669H75.109V452.4z'/%3E%3Cpath style='fill:%23E50027;' d='M436.891,452.4c16.628,0,30.851-8.27,39.063-22.669c8.211-14.414,8.065-31.087-0.322-45.485 L294.886,81.754c-8.388-13.871-22.933-22.157-38.887-22.157V452.4H436.891z'/%3E%3Cpath style='fill:%23E1E4FB;' d='M286.03,152.095v120.122c0,16.517-13.514,30.03-30.03,30.03s-30.031-13.514-30.031-30.03V152.095 c0-16.517,13.514-30.031,30.031-30.031S286.03,135.578,286.03,152.095z'/%3E%3Cpath style='fill:%23C5C9F7;' d='M286.03,152.095v120.122c0,16.517-13.514,30.03-30.03,30.03V122.064 C272.516,122.064,286.03,135.578,286.03,152.095z'/%3E%3Cpath style='fill:%23E1E4FB;' d='M256,332.278c-24.926,0-45.046,20.119-45.046,45.046c0,24.924,20.119,45.046,45.046,45.046 s45.046-20.121,45.046-45.046C301.046,352.398,280.925,332.278,256,332.278z'/%3E%3Cpath style='fill:%23C5C9F7;' d='M301.046,377.323c0,24.924-20.119,45.046-45.046,45.046v-90.091 C280.925,332.278,301.046,352.398,301.046,377.323z'/%3E%3C/svg%3E%0A");
    width: 60px;
    height: 60px;
    margin: 0 auto 20px;
  }
</style>



<script>
import Autocomplete from "@/components/app/Autocomplete"
import DataInput from '@/components/app/DataInput'


export default {
  props: ['data', 'hidden'],

  data: () => ({
    directions: {
      countries: '',
      countries_id: '',
      countries_img: '',
      is_main: false,
      manager: '',
      manager_id: '',
    },
    transport_companies: {
      type: '',
      type_id: '',
      quantity: '',
      capacity: '',
      volume: '',
    },
    
    
  }),



  async created() {
    function boolean(val){
      return (val == 0) ? (false) : true
    }


    console.log(this.data)
    if(this.data.name.mode == 'directions'){
      if(this.data.mod == 'update' || this.data.mod == 'copy'){
        this.directions.countries = this.data.lists[this.data.index].country_name
        this.directions.countries_id = this.data.lists[this.data.index].country_id

        this.directions.is_main = boolean(this.data.lists[this.data.index].is_main)

        this.directions.manager = this.data.lists[this.data.index].manager_name
        this.directions.manager_id = this.data.lists[this.data.index].manager_id
      }
    }
    if(this.data.name.mode == 'transport_companies'){
      if(this.data.mod == 'update' || this.data.mod == 'copy'){
        
        this.transport_companies.type = this.data.lists[this.data.index].container_type_name
        this.transport_companies.type_id = this.data.lists[this.data.index].container_type
        this.transport_companies.quantity = this.data.lists[this.data.index].num
        this.transport_companies.capacity = this.data.lists[this.data.index].lifting_capacity
        this.transport_companies.volume = this.data.lists[this.data.index].cargo_volume
      }
    }
    




    
  },




  methods: {
    //autocomplete
    autocompleteResult(data){
      if(this.data.name.mode == 'directions'){
        this.directions[data.input] = data.name
        this.directions[data.input + '_id'] = data.id
        if(data.img){
          this.directions.countries_img = data.img
        }
      } else if(this.data.name.mode == 'transport_companies'){
        this.transport_companies[data.input] = data.name
        this.transport_companies[data.input + '_id'] = data.id
      } else if(this.data.name.mode == 'carriers'){
        this.carriers[data.input] = data.name
        this.carriers[data.input + '_id'] = data.id
      }
      
    },

    dataInput(data){
      if(this.data.name.mode == 'freight'){
        this.freight[data.input] = data.date
      }
    },


    async removedata(){
      if(this.data.name.mode == 'directions') {
        var data = {
          id: this.data.id,
          name: this.data.data.name,
          countries_carriage: []
        }
        let app = this
        app.data.data.countries_carriage.forEach(function(item, index){
          if(item.id !== app.data.lists[app.data.index].id){
            data.countries_carriage.push(item)
          }
        })
        var update = await this.$store.dispatch('updateСounterparties', data);
      }

      if(this.data.name.mode == 'transport_companies') {
        var data = {
          id: this.data.id,
          name: this.data.data.name,
          transport_companies: []
        }
        let app = this
        app.data.data.transport_companies.forEach(function(item, index){
          if(item.id !== app.data.lists[app.data.index].id){
            data.transport_companies.push(item)
          }
        })
        var update = await this.$store.dispatch('updateСounterparties', data);
      }
      this.$emit('close', true)
    },
    

    







    async save(){
      function boolean(val){
        return (val == false) ? 0 : 1
      }


      
      //data
      if(this.data.name.mode == 'directions') {
        var data = {
          id: this.data.id,
          name: this.data.data.name,
          countries_carriage: []
        }
        if(this.data.mod == 'update' || this.data.mod == 'create'){
          let app = this

          if(app.data.mod == 'create'){
            data.countries_carriage = app.data.lists
            data.countries_carriage.push({
              country_id: app.directions.countries_id,
              is_main: boolean(app.directions.is_main),
              manager_id: app.directions.manager_id,
            })
          } else{
            app.data.data.countries_carriage.forEach(function(item, index){
              if(item.id == app.data.lists[app.data.index].id){
                data.countries_carriage.push({
                  country_id: app.directions.countries_id,
                  is_main: boolean(app.directions.is_main),
                  manager_id: app.directions.manager_id,
                  id: app.data.lists[app.data.index].id
                },)
              } else{
                data.countries_carriage.push(item)
              }
            })
          }  
        } else{
          let app = this
          app.data.data.countries_carriage.forEach(function(item, index){
            if(item.id == app.data.lists[app.data.index].id){
              data.countries_carriage.push(item)
              data.countries_carriage.push(item)
            } else{
              data.countries_carriage.push(item)
            }
          })
        }
        var update = await this.$store.dispatch('updateСounterparties', data);
      }



      

      if(this.data.name.mode == 'transport_companies') {
        var data = {
          id: this.data.id,
          name: this.data.data.name,
          transport_companies: []
        }
        if(this.data.mod == 'update' || this.data.mod == 'create'){
          let app = this

          if(app.data.mod == 'create'){
            data.transport_companies = app.data.lists
            data.transport_companies.push({
              container_type: app.transport_companies.type_id,
              num: app.transport_companies.quantity,
              lifting_capacity: app.transport_companies.capacity,
              cargo_volume: app.transport_companies.volume
            })
          } else{
            app.data.data.transport_companies.forEach(function(item, index){
              if(item.id == app.data.lists[app.data.index].id){
                data.transport_companies.push({
                  container_type: app.transport_companies.type_id,
                  num: app.transport_companies.quantity,
                  lifting_capacity: app.transport_companies.capacity,
                  cargo_volume: app.transport_companies.volume,
                  id: app.data.lists[app.data.index].id
                },)
              } else{
                data.transport_companies.push(item)
              }
            })
          }  
        } else{
          let app = this
          app.data.data.transport_companies.forEach(function(item, index){
            if(item.id == app.data.lists[app.data.index].id){
              data.transport_companies.push(item)
              data.transport_companies.push(item)
            } else{
              data.transport_companies.push(item)
            }
          })
        }
        var update = await this.$store.dispatch('updateСounterparties', data);
      }




      this.$emit('close', true)
    },
  },


  components: {
    Autocomplete, DataInput
  }
}
</script>